var _defs, _rect, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreativity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2390",
    "data-name": "Rettangolo 2390",
    width: 14.951,
    height: 17.578,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2381",
    "data-name": "Rettangolo 2381",
    width: 4.446,
    height: 5.111,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9800",
    "data-name": "Tracciato 9800",
    d: "M69.92,0a.251.251,0,0,0-.26.26v1.5a.262.262,0,0,0,.524,0V.26a.251.251,0,0,0-.26-.26Z",
    transform: "translate(-69.66)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -13.86,
    y1: 8.334,
    x2: -13.661,
    y2: 8.334,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#ffae00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffae00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9801",
    "data-name": "Tracciato 9801",
    d: "M24.408,16.4l.965,1.15a.262.262,0,0,0,.4-.337l-.965-1.15a.25.25,0,0,0-.194-.1.265.265,0,0,0-.208.434",
    transform: "translate(-24.343 -15.963)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1.39,
    y1: 8.599,
    x2: -1.331,
    y2: 8.599,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9802",
    "data-name": "Tracciato 9802",
    d: "M0,57.626v0a.247.247,0,0,0,.215.251l1.479.261a.262.262,0,0,0,.091-.516L.306,57.364a.309.309,0,0,0-.054,0A.256.256,0,0,0,0,57.626",
    transform: "translate(0 -57.359)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0,
    y1: 13.76,
    x2: 0.049,
    y2: 13.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9803",
    "data-name": "Tracciato 9803",
    d: "M9.308,97.549l-1.3.751a.262.262,0,0,0,.262.454L9.571,98a.265.265,0,0,0-.127-.493.271.271,0,0,0-.136.039",
    transform: "translate(-7.875 -97.51)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.309,
    y1: 5.225,
    x2: -0.26,
    y2: 5.225,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9804",
    "data-name": "Tracciato 9804",
    d: "M117.071,98.787a.262.262,0,0,0,.1.358l1.3.751a.262.262,0,1,0,.262-.454l-1.3-.751a.262.262,0,0,0-.358.1",
    transform: "translate(-117.036 -98.656)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -6.41,
    y1: 5.548,
    x2: -6.355,
    y2: 5.548,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9805",
    "data-name": "Tracciato 9805",
    d: "M125.8,58.628l-1.479.261a.262.262,0,1,0,.091.516l1.479-.261a.247.247,0,0,0,.215-.247v-.01a.256.256,0,0,0-.252-.264.307.307,0,0,0-.054,0",
    transform: "translate(-124.099 -58.623)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -6.39,
    y1: 14.196,
    x2: -6.339,
    y2: 14.196,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9806",
    "data-name": "Tracciato 9806",
    d: "M106.381,16.886l-.965,1.15a.262.262,0,0,0,.4.337l.965-1.15a.265.265,0,0,0-.208-.434.25.25,0,0,0-.194.1",
    transform: "translate(-105.351 -16.789)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -6.171,
    y1: 8.555,
    x2: -6.112,
    y2: 8.555,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5589",
    "data-name": "Raggruppa 5589",
    transform: "translate(-1222 -483)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2496",
    "data-name": "Rettangolo 2496",
    width: 24,
    height: 24,
    transform: "translate(1222 483)",
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_552",
    "data-name": "Ellisse 552",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(1224 485)",
    fill: "#f5f1ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5561",
    "data-name": "Raggruppa 5561",
    transform: "translate(1226.497 485.76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5355",
    "data-name": "Raggruppa 5355",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5340",
    "data-name": "Raggruppa 5340"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5339",
    "data-name": "Raggruppa 5339",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9768",
    "data-name": "Tracciato 9768",
    d: "M62.379,160.871a.934.934,0,0,1-.038.1,1.091,1.091,0,0,1-1,.656H61a1.09,1.09,0,0,1-1-.656h0a.931.931,0,0,1-.037-.1,18.337,18.337,0,0,1,2.414,0",
    transform: "translate(-53.708 -144.049)",
    fill: "#0d2675"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9769",
    "data-name": "Tracciato 9769",
    d: "M49.208,127.688l.247.01a1.019,1.019,0,0,0-.192.071.391.391,0,0,0-.083.063.443.443,0,0,0-.129.313.434.434,0,0,0,.131.313.442.442,0,0,1-.114-.707.444.444,0,0,1,.082-.065Z",
    transform: "translate(-43.831 -114.364)",
    fill: "#4b9aea"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9770",
    "data-name": "Tracciato 9770",
    d: "M62.379,160.871l-.038.1a18.213,18.213,0,0,1-2.338,0h0a.931.931,0,0,1-.037-.1,18.337,18.337,0,0,1,2.414,0",
    transform: "translate(-53.708 -144.049)",
    fill: "#031944"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9771",
    "data-name": "Tracciato 9771",
    d: "M53.647,128.066a.439.439,0,0,1-.13.313.414.414,0,0,1-.128.089q-2.1-.1-4.2,0a.442.442,0,0,1-.128-.715.4.4,0,0,1,.082-.065H49.2q2.087.1,4.175,0h.059a.441.441,0,0,1,.212.378",
    transform: "translate(-43.825 -114.364)",
    fill: "#1a4be8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9772",
    "data-name": "Tracciato 9772",
    d: "M55.257,127.128H55.2q-2.087.1-4.175,0h-.059a.3.3,0,0,1,.044-.024.431.431,0,0,1,.186-.041h3.831a.431.431,0,0,1,.186.041.3.3,0,0,1,.045.024",
    transform: "translate(-45.647 -113.804)",
    fill: "#1a4be8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9773",
    "data-name": "Tracciato 9773",
    d: "M55.6,134.733h0a.053.053,0,0,0-.025.01h0a.435.435,0,0,1-.157.029H51.588a.432.432,0,0,1-.157-.029.055.055,0,0,0-.026-.01h0q2.1-.1,4.2,0",
    transform: "translate(-46.039 -120.63)",
    fill: "#1a4be8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9774",
    "data-name": "Tracciato 9774",
    d: "M55.595,153.68v.165a.6.6,0,0,1-.6.6H51.99a.6.6,0,0,1-.6-.6v-.165a.059.059,0,0,0,.043-.026h4.117a.059.059,0,0,0,.043.026",
    transform: "translate(-46.029 -137.621)",
    fill: "#1a4be8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9775",
    "data-name": "Tracciato 9775",
    d: "M53.647,136.325a.442.442,0,0,1-.257.4h0a.054.054,0,0,0-.026.01h0a.433.433,0,0,1-.157.029H49.374a.429.429,0,0,1-.157-.029h0a.054.054,0,0,0-.026-.01h0a.442.442,0,0,1-.127-.714.426.426,0,0,1,.127-.088.058.058,0,0,0,.032-.013.431.431,0,0,1,.154-.028H53.2a.425.425,0,0,1,.155.029.056.056,0,0,0,.031.013.44.44,0,0,1,.257.4",
    transform: "translate(-43.825 -121.703)",
    fill: "#1a4be8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9776",
    "data-name": "Tracciato 9776",
    d: "M53.647,145.137a.438.438,0,0,1-.13.313.413.413,0,0,1-.128.089h0a.051.051,0,0,0-.026.011h0a.429.429,0,0,1-.157.029H49.374a.425.425,0,0,1-.155-.029.059.059,0,0,0-.029-.012h0a.442.442,0,0,1-.128-.715.429.429,0,0,1,.127-.089.057.057,0,0,0,.032-.013.43.43,0,0,1,.154-.028H53.2a.424.424,0,0,1,.155.029.055.055,0,0,0,.031.013.441.441,0,0,1,.257.4",
    transform: "translate(-43.825 -129.595)",
    fill: "#1a4be8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9777",
    "data-name": "Tracciato 9777",
    d: "M51.507,153.756v.166a.593.593,0,0,0,.2.442.6.6,0,0,1-.308-.523v-.164a.057.057,0,0,0,.043-.027h4.118a.056.056,0,0,0,.038.026h0v.054H51.551c-.034,0-.044-.007-.044.026",
    transform: "translate(-46.031 -137.616)",
    fill: "#4b9aea"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9778",
    "data-name": "Tracciato 9778",
    d: "M53.521,136.008,53.509,136a.057.057,0,0,1-.031-.013.409.409,0,0,0-.155-.028h-3.83a.435.435,0,0,0-.154.027.057.057,0,0,1-.032.014.445.445,0,0,0-.127.088.44.44,0,0,0-.129.313.435.435,0,0,0,.132.313.441.441,0,0,1-.115-.707.417.417,0,0,1,.127-.089.052.052,0,0,0,.031-.013.424.424,0,0,1,.091-.023h0a.316.316,0,0,1,.061-.005H53.21a.443.443,0,0,1,.155.028.056.056,0,0,0,.03.013.448.448,0,0,1,.126.088",
    transform: "translate(-43.831 -121.699)",
    fill: "#4b9aea"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9779",
    "data-name": "Tracciato 9779",
    d: "M53.521,144.818l-.012-.006a.056.056,0,0,1-.031-.013.409.409,0,0,0-.155-.028h-3.83a.407.407,0,0,0-.154.028.066.066,0,0,1-.032.013.445.445,0,0,0-.127.088.44.44,0,0,0-.129.313.434.434,0,0,0,.131.313.443.443,0,0,1,.013-.8.045.045,0,0,0,.031-.013.425.425,0,0,1,.082-.022h0a.427.427,0,0,1,.07-.006H53.21a.413.413,0,0,1,.155.03.05.05,0,0,0,.026.01h0a.45.45,0,0,1,.126.088",
    transform: "translate(-43.831 -129.591)",
    fill: "#4b9aea"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9780",
    "data-name": "Tracciato 9780",
    d: "M52.706,135.878l-.12.005a.315.315,0,0,1,.061-.005Z",
    transform: "translate(-47.099 -121.699)",
    fill: "#1a4be8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9781",
    "data-name": "Tracciato 9781",
    d: "M56.581,144.729a.306.306,0,0,1-.069.006h-3.83a.448.448,0,0,1-.157-.028h0a.035.035,0,0,0-.025-.01h0a.429.429,0,0,1,.07-.006H56.4a.413.413,0,0,1,.155.03.05.05,0,0,0,.026.01",
    transform: "translate(-47.02 -129.591)",
    fill: "#1a4be8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9782",
    "data-name": "Tracciato 9782",
    d: "M56.77,153.675a.306.306,0,0,1-.069.006h-3.83a.44.44,0,0,1-.155-.028l-.007,0h4.023a.056.056,0,0,0,.038.026",
    transform: "translate(-47.209 -137.616)",
    fill: "#1a4be8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9783",
    "data-name": "Tracciato 9783",
    d: "M55.543,134.792h0a.059.059,0,0,0,.021.045.055.055,0,0,0,.03.013q-2.1.1-4.2,0a.058.058,0,0,0,.052-.058h0a.06.06,0,0,0-.023-.047.054.054,0,0,0-.026-.01h0q2.1-.1,4.2,0h0a.052.052,0,0,0-.025.01h0a.06.06,0,0,0-.023.047",
    transform: "translate(-46.029 -120.63)",
    fill: "#0d2675"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9784",
    "data-name": "Tracciato 9784",
    d: "M55.543,143.6h0a.059.059,0,0,0,.021.045.054.054,0,0,0,.03.013q-2.1.1-4.2,0a.058.058,0,0,0,.052-.058h0a.06.06,0,0,0-.023-.047h0a.052.052,0,0,0-.026-.01h0q2.1-.1,4.2,0h0a.052.052,0,0,0-.026.01h0a.06.06,0,0,0-.023.047",
    transform: "translate(-46.029 -128.523)",
    fill: "#0d2675"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9785",
    "data-name": "Tracciato 9785",
    d: "M55.595,152.478q-2.1.1-4.2,0a.059.059,0,0,0,.043-.026.062.062,0,0,0,.009-.032h0a.059.059,0,0,0-.022-.046.057.057,0,0,0-.029-.012q2.1-.1,4.2,0h0a.049.049,0,0,0-.026.011h0a.058.058,0,0,0-.023.046h0a.062.062,0,0,0,.009.032.059.059,0,0,0,.043.026",
    transform: "translate(-46.029 -136.418)",
    fill: "#0d2675"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9786",
    "data-name": "Tracciato 9786",
    d: "M81.585,128.065a.436.436,0,0,1-.131.312.42.42,0,0,1-.127.089c-.4-.018-.8-.032-1.2-.039a6.7,6.7,0,0,0,.35-.711c.281-.006.561-.017.842-.03h.058a.443.443,0,0,1,.212.378",
    transform: "translate(-71.762 -114.363)",
    fill: "#1234a1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9787",
    "data-name": "Tracciato 9787",
    d: "M80.939,134.825a0,0,0,0,0,0,0h0a.053.053,0,0,0-.025.01h0a.445.445,0,0,1-.157.028H79.689c.016-.026.03-.052.045-.079.4.006.8.021,1.2.039",
    transform: "translate(-71.374 -120.721)",
    fill: "#1a4be8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9788",
    "data-name": "Tracciato 9788",
    d: "M58.086,153.676v.164a.6.6,0,0,1-.6.6H54.481a.578.578,0,0,1-.307-.087,6.716,6.716,0,0,0,.962-.635l.085-.069h2.823a.061.061,0,0,0,.041.027",
    transform: "translate(-48.521 -137.616)",
    fill: "#1234a1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9789",
    "data-name": "Tracciato 9789",
    d: "M75.693,136.321a.443.443,0,0,1-.258.4h0a.052.052,0,0,0-.026.01h0a.417.417,0,0,1-.157.03H73.545l.073-.089a7.02,7.02,0,0,0,.5-.714l.051-.083H75.25a.441.441,0,0,1,.155.028.056.056,0,0,0,.03.013.441.441,0,0,1,.258.4",
    transform: "translate(-65.871 -121.699)",
    fill: "#1234a1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9790",
    "data-name": "Tracciato 9790",
    d: "M67.846,145.132a.436.436,0,0,1-.131.313.418.418,0,0,1-.127.089h0a.052.052,0,0,0-.027.012.448.448,0,0,1-.157.028h-2.62c.034-.027.067-.057.1-.087a6.775,6.775,0,0,0,.708-.708c.026-.03.052-.06.076-.091H67.4a.415.415,0,0,1,.155.03.054.054,0,0,0,.03.012.441.441,0,0,1,.258.4",
    transform: "translate(-58.024 -129.591)",
    fill: "#1234a1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9791",
    "data-name": "Tracciato 9791",
    d: "M80.3,134.928a.056.056,0,0,0,.03.013q-.66.031-1.321.041l.05-.083.021-.035c.016-.026.03-.052.045-.079.4.006.8.021,1.2.039a0,0,0,0,0,0,0h0a.052.052,0,0,0-.025.01h0a.061.061,0,0,0-.023.047h0a.056.056,0,0,0,.022.044",
    transform: "translate(-70.762 -120.721)",
    fill: "#031944"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9792",
    "data-name": "Tracciato 9792",
    d: "M74.484,143.616h0a.061.061,0,0,0,.022.045.054.054,0,0,0,.03.012c-.666.031-1.329.048-2,.049.026-.03.052-.06.076-.091l.028-.034.073-.089c.607,0,1.212.02,1.818.048h0a.052.052,0,0,0-.026.01h0a.063.063,0,0,0-.023.047",
    transform: "translate(-64.971 -128.535)",
    fill: "#031944"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9793",
    "data-name": "Tracciato 9793",
    d: "M66.345,152.476q-1.474.07-2.95.041l.085-.069c.021-.016.04-.032.06-.049s.067-.057.1-.087q1.352-.017,2.7.047a.052.052,0,0,0-.027.012.056.056,0,0,0-.023.045h0a.053.053,0,0,0,.01.031.061.061,0,0,0,.041.027",
    transform: "translate(-56.78 -136.416)",
    fill: "#031944"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9794",
    "data-name": "Tracciato 9794",
    d: "M32.524,29.086a4.553,4.553,0,0,1,3.022,7.89.665.665,0,0,0-.218.488v1.308a.6.6,0,0,1-.6.6h-.189q-2.087.1-4.175,0h-.189a.6.6,0,0,1-.6-.6V37.457a.651.651,0,0,0-.213-.477,4.553,4.553,0,0,1,3.167-7.894",
    transform: "translate(-24.986 -26.05)",
    fill: "#f9d217"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9795",
    "data-name": "Tracciato 9795",
    d: "M34.466,36.837a4.55,4.55,0,0,0,.775.938.651.651,0,0,1,.213.477v1.315a.6.6,0,0,0,.6.6h.189q2.087.1,4.175,0h.189a.6.6,0,0,0,.6-.6V38.26a.665.665,0,0,1,.218-.488,4.552,4.552,0,0,0-2.184-7.8,9.578,9.578,0,0,1,1.248,1.268,4.315,4.315,0,0,1,1,2.36,2.63,2.63,0,0,1-.988,2.287c-.434.313-1,.479-1.3.923a2.733,2.733,0,0,0-.263,1.461,1.463,1.463,0,0,1-.592,1.307,1.192,1.192,0,0,1-1.307-.3,8.5,8.5,0,0,1-.855-1.146,3.97,3.97,0,0,0-1.72-1.293",
    transform: "translate(-30.87 -26.846)",
    fill: "#f5b014"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9796",
    "data-name": "Tracciato 9796",
    d: "M35.33,34.066c-.976.976-1.232,2.3-.57,2.966s1.989.406,2.965-.57,1.232-2.3.57-2.965-1.989-.406-2.966.57",
    transform: "translate(-30.803 -29.671)",
    fill: "#fbe525"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9797",
    "data-name": "Tracciato 9797",
    d: "M55.558,34.61c-.237.038-.408.2-.382.359s.238.26.475.222.408-.2.382-.359-.238-.26-.475-.222",
    transform: "translate(-49.416 -30.991)",
    fill: "#fffade"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9798",
    "data-name": "Tracciato 9798",
    d: "M51.476,38.066c-.076.029-.122.094-.1.146s.1.07.173.041.122-.094.1-.146-.1-.069-.173-.04",
    transform: "translate(-46.01 -34.082)",
    fill: "#fffade"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5338",
    "data-name": "Raggruppa 5338",
    transform: "translate(5.213 8.257)",
    opacity: 0.5,
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5337",
    "data-name": "Raggruppa 5337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5336",
    "data-name": "Raggruppa 5336",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9799",
    "data-name": "Tracciato 9799",
    d: "M54.07,79.316a.735.735,0,0,0-.914.32,1.855,1.855,0,0,0-.213.9c-.006.113-.012.225-.018.338a2.753,2.753,0,0,1-1.585-.117l-.028-.46a1.612,1.612,0,0,0-.241-.875.758.758,0,0,0-.512-.294.535.535,0,0,0-.417.121.627.627,0,0,0-.16.642,1.22,1.22,0,0,0,.334.512,2.713,2.713,0,0,0,.775.535q.066,1.265.05,2.536c0,.217-.006.435-.014.652l0,.1.26.005c0-.035,0-.071,0-.105.005-.173.008-.345.011-.518q.022-1.284-.042-2.564a2.966,2.966,0,0,0,1.557.1c0,.018,0,.034,0,.052h0q-.065,1.463-.078,2.928c0,.036,0,.073,0,.108l.129,0h.065l.064,0c0-.035,0-.068,0-.1.007-1.017.036-2.036.084-3.049a2.679,2.679,0,0,0,.591-.265,1.3,1.3,0,0,0,.59-.642.829.829,0,0,0,.045-.28.65.65,0,0,0-.331-.578m-3.572.909a.934.934,0,0,1-.266-.4.376.376,0,0,1,.081-.376.265.265,0,0,1,.179-.062h.039a.509.509,0,0,1,.332.192,1.416,1.416,0,0,1,.191.74c.007.107.014.215.02.322a2.413,2.413,0,0,1-.575-.418m3.614-.142s0,0,0,0a1.035,1.035,0,0,1-.48.509,2.318,2.318,0,0,1-.441.208c0-.039,0-.076.006-.114s0-.09.006-.135a1.638,1.638,0,0,1,.173-.78.551.551,0,0,1,.431-.262.317.317,0,0,1,.145.034.453.453,0,0,1,.162.535h0Z",
    transform: "translate(-49.955 -79.129)",
    fill: "#fffade"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5342",
    "data-name": "Raggruppa 5342",
    transform: "translate(7.269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5341",
    "data-name": "Raggruppa 5341",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2383",
    "data-name": "Rettangolo 2383",
    width: 0.524,
    height: 2.109,
    fill: "url(#linear-gradient)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5344",
    "data-name": "Raggruppa 5344",
    transform: "translate(2.54 1.666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5343",
    "data-name": "Raggruppa 5343",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2384",
    "data-name": "Rettangolo 2384",
    width: 1.755,
    height: 1.85,
    transform: "translate(-0.1 0)",
    fill: "url(#linear-gradient-2)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5346",
    "data-name": "Raggruppa 5346",
    transform: "translate(0 5.985)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5345",
    "data-name": "Raggruppa 5345",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2385",
    "data-name": "Rettangolo 2385",
    width: 2.127,
    height: 0.842,
    fill: "url(#linear-gradient-3)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5348",
    "data-name": "Raggruppa 5348",
    transform: "translate(0.822 10.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5347",
    "data-name": "Raggruppa 5347",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2386",
    "data-name": "Rettangolo 2386",
    width: 2.117,
    height: 1.417,
    transform: "translate(-0.168)",
    fill: "url(#linear-gradient-4)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5350",
    "data-name": "Raggruppa 5350",
    transform: "translate(12.212 10.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5349",
    "data-name": "Raggruppa 5349",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2387",
    "data-name": "Rettangolo 2387",
    width: 1.9,
    height: 1.313,
    transform: "translate(-0.037 0)",
    fill: "url(#linear-gradient-5)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5352",
    "data-name": "Raggruppa 5352",
    transform: "translate(12.949 6.117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5351",
    "data-name": "Raggruppa 5351",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2388",
    "data-name": "Rettangolo 2388",
    width: 2.023,
    height: 0.807,
    transform: "translate(-0.021)",
    fill: "url(#linear-gradient-6)"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5354",
    "data-name": "Raggruppa 5354",
    transform: "translate(10.993 1.752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5353",
    "data-name": "Raggruppa 5353",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2389",
    "data-name": "Rettangolo 2389",
    width: 1.756,
    height: 1.85,
    transform: "translate(-0.158 0)",
    fill: "url(#linear-gradient-7)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreativity);
export default __webpack_public_path__ + "static/media/creativity.b9754f8a734401c3e3e826f11cd0a3b0.svg";
export { ForwardRef as ReactComponent };